import { Link } from 'react-router-dom';
import { categories, mainSiteUrl, seoArticles } from '@/mocks/vigorbuy-data';

export default function Footer() {
  return (
    <footer className="w-full bg-accent-900 pt-14 pb-8">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 mb-10">
          <div>
            <h4 className="font-heading text-lg font-bold text-white mb-4">
              VigorBuy<span className="text-primary-400">Spreadsheet</span>
            </h4>
            <p className="text-accent-100/60 text-sm leading-relaxed mb-4">
              The ultimate product discovery and shopping research guide. Helping shoppers find better products faster since 2026.
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line text-sm"></i>
            </a>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-accent-100/60 text-sm hover:text-white transition-colors">Home</Link></li>
              <li><a href="/#categories" className="text-accent-100/60 text-sm hover:text-white transition-colors cursor-pointer">Categories</a></li>
              <li><a href="/#comparison" className="text-accent-100/60 text-sm hover:text-white transition-colors cursor-pointer">Comparison</a></li>
              <li><Link to="/vigorbuy-beginner-guide" className="text-accent-100/60 text-sm hover:text-white transition-colors">Beginner Guide</Link></li>
              <li><Link to="/vigorbuy-spreadsheet-safety" className="text-accent-100/60 text-sm hover:text-white transition-colors">Safety Guide</Link></li>
              <li><a href="/#faq" className="text-accent-100/60 text-sm hover:text-white transition-colors cursor-pointer">FAQ</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">Shopping Guides</h4>
            <ul className="space-y-2.5">
              {seoArticles.map((article, idx) => (
                <li key={idx}>
                  <Link to={`/${article.slug}`} className="text-accent-100/60 text-sm hover:text-white transition-colors">
                    {article.title.length > 45 ? article.title.slice(0, 45) + '...' : article.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">Popular Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat, idx) => (
                <li key={idx}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-accent-100/60 text-sm hover:text-white transition-colors cursor-pointer">
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-white mb-4">More Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(7).map((cat, idx) => (
                <li key={idx}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-accent-100/60 text-sm hover:text-white transition-colors cursor-pointer">
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-accent-700/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-accent-100/40 text-xs">
            &copy; {new Date().getFullYear()} VigorBuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-accent-100/40 text-xs hover:text-white transition-colors cursor-pointer">
              Main Website
            </a>
            <Link to="/vigorbuy-spreadsheet-guide" className="text-accent-100/40 text-xs hover:text-white transition-colors">
              Guide
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}